module.exports = __webpack_public_path__ + "img/line_01.072f284f.png";